import Pageheader from 'components/Pageheader';
import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';
import useTranslations from 'i18n/useTranslations';
import ModalContext from 'contexts/ModalContext';
import { GetPointHistory } from 'services/Api/Module/PointHistory';
import helper from 'services/helper';
import moment from 'moment';
import useProfileStore from 'services/store/ProfileModule';
import DatePicker from 'components/DatePicker';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';

const YEAR_MONTH_OPTION = helper.GEN.YEAR_MONTH_OPTION('2024-08')
const DEF_YEAR_MONTH = moment().format('YYYY-MM')

const HistoryPoint = () => {
    const profile = useProfileStore();
    const { mAlert } = useContext(ModalContext);
    const navigate = useNavigate();

    const { lang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();

    const [ pointHistory, setPointHistory ] = useState([])

    //
    const [pointType, setPointType] = useState('');
    const [yearMonth, setYearMonth] = useState(DEF_YEAR_MONTH);

    const [refreshing, setRefreshing] = useState(false)

    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    }

    const onLoad = () =>  {
        const payload = {
            // pointType: 1,
            // customerId: 57210,
            customerId: profile.customerProfile.id,
            yearMonth: yearMonth,
        }
        fetchGetCoupon(payload)
    }

    const handleBack = () => {
        navigate(`/profile`)
    }
    const gotoCouponRedeemPage = (row) => {
        navigate(`/coupon-qr?id=${row.couponRedeemId}&restaurantId=${row.restaurantId}&branchId=${row.restaurantBranchId}` + '&fromPage=history-point')
    }
    
    const fetchGetCoupon = async (payload) => {
        try {
            const response = await GetPointHistory({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setPointHistory(resData.resultData)
            } 
            setRefreshing(false)
            
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchAPI = () => {
        const payload = {
            // pointType: 1,
            // customerId: 57210,
            customerId: profile.customerProfile.id,
            yearMonth: yearMonth,
        }
        fetchGetCoupon(payload)
    }

    useEffect(() => {
        if (profile?.lineUid && profile?.customerProfile?.id) {
            fetchAPI()
        }
        console.log('useEffect profile >>', profile)
    }, [yearMonth, profile]);

    const checkExpire = (expireDateTime) => {
        const targetDate = expireDateTime ? moment(expireDateTime) : moment()
        const now = moment(); // สร้างเวลาปัจจุบันใน UTC+0
        const nowMinus7Hours = now.subtract(7, 'hours');
        const timeDifference = moment.duration(targetDate.diff(nowMinus7Hours));
        console.log(timeDifference)
        if (timeDifference.asMilliseconds() <= 0) {
            return true
        }
        return false
    }

    return (
        <PullToRefresh
            refreshing={refreshing}
            onRefresh={handleRefresh}
            >
                <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageHistory">
                <Pageheader pagename={t.historyPoint.header} onClick={handleBack} />
                <main>
                    <div className="wrapContent">
                        <section id="pFilterHistory">
                            <div className="bFilter">
                            <div className="bRow">
                                <DatePicker
                                    value={yearMonth}
                                    onChange={(newValue) => {
                                        console.log("🚀 ~ HistoryPoint ~ newValue:", newValue)
                                        setYearMonth(newValue)
                                    }}
                                />
                                {/* <div className="control-group">
                                    <div className="select">
                                        <div className="select">
                                            <select value={yearMonth} onChange={(e) => setYearMonth(e.target.value)}>
                                                {YEAR_MONTH_OPTION.map((item) => (
                                                    <option key={item.id} value={item.id}>{helper.FN.mapYearMonthLang(item.name, 'th')}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            </div>
                            <div className="bCategory">
                                <a className={[1,2].includes(pointType) === false ? 'active': '' } onClick={() => setPointType(0)} >{t.historyPoint.pointType.all}</a>
                                <a className={pointType === 1 ? 'active': '' } onClick={() => setPointType(1)}>{t.historyPoint.pointType.earn}</a>
                                <a className={pointType === 2 ? 'active': '' } onClick={() => setPointType(2)}>{t.historyPoint.pointType.redeem}</a>
                            </div>
                        </section>
                        <section id="pHistory">
                            {
                                (() => {
                                    const filteredHistory = pointHistory.filter(item => [1, 2].includes(pointType) === false || item.pointType === pointType);

                                    return filteredHistory.length > 0 ? (
                                        <div className="bGroup">
                                            {
                                                filteredHistory.map(item => {
                                                    const isExpire = checkExpire(item.expiredAt);
                                                    let useStatus = { label: '', status: '', point: '' };

                                                    if (item.isTpd == 1) {
                                                        useStatus = {};
                                                    } else if (item.isUsed == 1) {
                                                        useStatus = { label: t.historyPoint.pointHistoryStatus.redeemSuccess , status: 'complete', point: 'burn' };
                                                    } else if (isExpire) {
                                                        useStatus = { label: t.historyPoint.pointHistoryStatus.expired , status: 'expire', point: 'get' };
                                                    } else {
                                                        useStatus = { label: t.historyPoint.pointHistoryStatus.pending , status: 'waiting', point: 'free' };
                                                    }

                                                    return (
                                                        <article key={item.id} data-type={item.pointType === 1 ? 'point' : 'coupon' } data-status={useStatus.status} data-point={useStatus.point}>
                                                            <div className="bTitle">
                                                                {item.isTpd === 1 && (
                                                                    <>
                                                                        {item.pointType === 1 && <h3>{t.historyPoint.pointType.collect}</h3>}
                                                                        {item.pointType === 2 && <h3>{t.historyPoint.pointType.used} <span style={{ fontSize: '12px' }}>{useStatus.label}</span></h3>}
                                                                    </>
                                                                )}
                                                                
                                                                {/* ถ้าไม่ใช่ Tpd แต่ยังคงแสดง pointType เดิมได้ */}
                                                                {item.isTpd !== 1 && (
                                                                    <>
                                                                        {item.pointType === 1 && <h3>{t.historyPoint.pointType.earn}</h3>}
                                                                        {item.pointType === 2 && <h3>{t.historyPoint.pointType.redeem} <span style={{ fontSize: '12px' }}>{useStatus.label}</span></h3>}
                                                                    </>
                                                                )}

                                                                {item.couponRedeemId && (
                                                                    <a onClick={() => gotoCouponRedeemPage(item)}>
                                                                        {t.historyPoint.couponView}
                                                                    </a>
                                                                )}
                                                            </div>

                                                            <div className="bDetails">
                                                            {item.isTpd === 1 ? (
                                                                <div className="bRow">
                                                                    <h4>{t.historyPoint.pointHistoryDetail.transactionFrom}</h4>
                                                                    <p>{'TPD'}</p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="bRow">
                                                                        <h4>{t.historyPoint.pointHistoryDetail.restaurant}</h4>
                                                                        <p>{item?.restaurantName ?? '-'}</p>
                                                                    </div>
                                                                    {item.pointType === 1 && (
                                                                        <div className="bRow">
                                                                            <h4>{t.historyPoint.pointHistoryDetail.branch}</h4>
                                                                            <p>{item?.restaurantBranchName ?? '-'}</p>
                                                                        </div>
                                                                        )}
                                                                </>
                                                            )}

                                                                <div className="bRow">
                                                                    { item.pointType === 1 && (<h4>{t.historyPoint.pointHistoryDetail.earnPoint}</h4>)}
                                                                    { item.pointType === 2 && (<h4>{t.historyPoint.pointHistoryDetail.usedPoint}</h4>)}
                                                                    <p> <span style={{ color:(item.pointType === 1 ? 'green' : 'red') }}>
                                                                            {item.point > 0 ? helper.FN.toNumberWithCommas(item.point) : '0'}
                                                                        </span>  {t.profile.points}</p>
                                                                </div>
                                                                <div className="bRow">
                                                                    { item.pointType === 1 && (<h4>{t.historyPoint.pointHistoryDetail.dateTime}</h4>)}
                                                                    { item.pointType === 2 && (<h4>{t.historyPoint.pointHistoryDetail.usedDate}</h4>)}
                                                                    <p>{item.createdOn ? helper.TIME.toShortDateTimeNormalLang(item.createdOn) : '-' }</p>
                                                                </div>
                                                                {item.isTpd === 1 ? (
                                                                    <>
                                                                        <div className="bRow">
                                                                            <h4>{t.historyPoint.pointHistoryDetail.referenceTdp}</h4>
                                                                            <p>{item.referenceFromTpd ?? '-'}</p> {/* หรือค่าอื่นที่คุณต้องการ */}
                                                                        </div>
                                                                        <div className="bRow">
                                                                            <h4>{t.historyPoint.pointHistoryDetail.referenceImpact}</h4>
                                                                            <p>{item.reference ?? '-'}</p> {/* หรือค่าอื่นที่คุณต้องการ */}
                                                                        </div>
                                                                    </>
                                                                    
                                                                ) : (
                                                                    item.pointType === 2 && (
                                                                        <>
                                                                            <div className="bRow">
                                                                                <h4>{t.historyPoint.pointHistoryDetail.couponName}</h4>
                                                                                <p>{item.couponName ? helper.FN.splitText(item.couponName, 24) : '-'}</p>
                                                                            </div>
                                                                            <div className="bRow">
                                                                                <h4>{t.historyPoint.pointHistoryDetail.couponCode}</h4>
                                                                                <p>{item.couponCode ? item.couponCode : '-'}</p>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                )}
                                                            </div>
                                                        </article>
                                                    );
                                                })
                                            }
                                        </div>
                                    ) : (
                                        <div className="bCouponNone">
                                            <div className="bText">
                                                <i></i>
                                                <p>{t.historyPoint.noHistory}</p>
                                            </div>
                                        </div>
                                    );
                                })()
                            }
                        </section>         
                    </div>
                </main>
            </div>
        </div>

        </PullToRefresh>
    )
}

export default HistoryPoint

